import {SkeletonBlock} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const CategoryBreadcrumbsLoading = () => {
  return (
    <SkeletonWrapper data-testid="StreamHeaderLoadingView">
      <SkeletonBlock $width="30%" $height="19px" />
    </SkeletonWrapper>
  );
};

const SkeletonWrapper = styled.section`
  width: 100%;
`;
